var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.407 36.9C33.3758 39.5438 30.8633 41.25 28.032 41.25H16.9695C14.1195 41.25 11.6258 39.5438 10.5945 36.9C9.56326 34.2375 10.2758 31.2937 12.3758 29.3813L19.9695 22.5H25.0508L32.6258 29.3813C34.7258 31.2937 35.4195 34.2375 34.407 36.9Z",
    fill: "#00D3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.912 34.0109H19.087C18.3745 34.0109 17.812 33.4297 17.812 32.7359C17.812 32.0234 18.3933 31.4609 19.087 31.4609H25.912C26.6245 31.4609 27.187 32.0422 27.187 32.7359C27.187 33.4297 26.6058 34.0109 25.912 34.0109Z",
    fill: "#00D3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4065 8.1C33.3752 5.45625 30.8627 3.75 28.0315 3.75H16.969C14.1377 3.75 11.6252 5.45625 10.594 8.1C9.58149 10.7625 10.2752 13.7063 12.394 15.6187L19.969 22.5H25.0502L32.6252 15.6187C34.7252 13.7063 35.419 10.7625 34.4065 8.1ZM25.9127 13.5562H19.0877C18.3752 13.5562 17.8127 12.975 17.8127 12.2812C17.8127 11.5875 18.394 11.0062 19.0877 11.0062H25.9127C26.6252 11.0062 27.1877 11.5875 27.1877 12.2812C27.1877 12.975 26.6065 13.5562 25.9127 13.5562Z",
    fill: "#00D3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.d54f137b8438e69f193e6e24c6c855d3.svg";
export { ForwardRef as ReactComponent };